// extracted by mini-css-extract-plugin
module.exports = {"grayContainer":"style_grayContainer__3GlVj","wrapper":"style_wrapper__jDSv1","card":"style_card__12rAk","cover":"style_cover__lemiQ","coverImage":"style_coverImage__3ZR4K"};